import React from "react";
import SelectArrowIcon from "../../../../icons/select-arrow.icon";
import styles from "./subscription-settings-line.module.scss";

export const SubscriptionSettingsLine = ({ currentPlan = "Disti Plan" }) => {
  return (
    <div className={styles.container}>
     

      <button
        type="button"
        className={styles.button}
        aria-label="Select subscription plan"
        aria-haspopup="listbox"
        aria-expanded="false"
      >
        <div className={styles.planContainer}>
          <span className={styles.planText}>
            {currentPlan}
          </span>
        </div>

        <div className={styles.iconContainer}>
          <SelectArrowIcon className={styles.icon} fill="#616778" />
        </div>
      </button>
    </div>
  );
};